<template>
    <div id="update-w3-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>{{ $t("whatsapp_business_api.channelName") }}</label>
                    <a-input
                        :placeholder="$t('whatsapp_business_api.channelName')"
                        v-model="clone.name"
                        v-validate="'required'"
                        name="channelName"
                    />
                </div>

                <div class="input-wrapper">
                    <div class="mt-1 mb-1">
                        <a-switch :checked="!!clone.forward.story" @click="toggleChatbot" />
                        <span>👉 {{ $t("whatsapp_business_api.forwardToChatbot") }}</span>
                    </div>

                    <label>{{ $t("whatsapp_business_api.forwarding") }}</label>
                    <a-select
                        v-model="clone.forward.story"
                        @change="handleStoryChange"
                        :defaultValue="null"
                        :notFoundContent="$t('whatsapp_business_api.forwardLiveAgents')"
                        :disabled="!showStories"
                    >
                        <a-select-option :selected="true" :value="null">
                            {{ $t("whatsapp_business_api.forwardLiveAgents") }}</a-select-option
                        >
                        <a-select-option :key="story._id" v-for="story in stories" :value="story._id">
                            {{ story.title }}
                        </a-select-option>
                    </a-select>
                </div>
                <!--                <VisibilityChanger v-model="clone.visibility" />-->
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <a-button @click="handleCancel">{{ $t("message.cancel") }}</a-button>
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                    {{ $t("message.update") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import VisibilityChanger from "../../WhatsappV1/VisibilityChanger.vue";

export default {
    name: "UpdateW3Channel",
    components: {
        VisibilityChanger,
    },
    props: {
        channel: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.channel),
            loading: false,
            showStories: !!this.channel.forward.story,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            stories: (state) => state.CB.stories,
        }),
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listChannels: "channel/listChannels",
        }),
        toggleChatbot() {
            if (this.showStories) {
                this.clone.forward.story = null;
            } else {
                if (this.stories[0]) {
                    this.clone.forward.story = this.stories[0]._id;
                }
            }
            this.showStories = !this.showStories;
        },
        handleCancel() {
            this.$emit("cancel");
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.clone;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success("Channel updated successfully");
                        this.$emit("ok");
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error("Failed to update channel");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        handleStoryChange() {},
    },
    mounted() {},
    beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
#update-w3-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }

    .webhook-info {
        display: flex;
        gap: 5px;
        justify-content: center;
        padding: 5px;
        overflow-wrap: anywhere;

        .anticon {
            &:hover {
                color: var(--color-text-info-hover);
            }
        }
    }
}
</style>

<style lang="scss">
.new-waba {
    .custom-modal-body {
        padding: 0px !important;
    }
}
</style>
